import type { TreeTag } from '#domains/tags/types';

export type OptimisticEditPayload = {
  tag: TreeTag;
};

export const optimisticEdit = (
  state: TreeTag[],
  { tag }: OptimisticEditPayload
) => {
  return state.map(t => {
    if (t.id === tag.id) {
      return { ...t, ...tag };
    }

    return t;
  });
};
